class CertificatePage {
  constructor(container) {
      this.$container = container;
      this.init();
  }

  init() {
      const $form = document.querySelector(".certificate-page-heading__form");
      const url = "/?section_id=query-collection-not-delete&page=";
      const $productsContainer = document.querySelector(
          ".certificate-page-heading__products"
      );
      const textProductNotFound = $productsContainer.getAttribute(
          "data-text-not-found"
      );
      const $loader = document.querySelector(
          ".certificate-page-loader"
      );
      const submitButton = document.getElementById("certificate-page__btn");
      const self = this;

      const submitForm = () => {
        const lotNumberInput = $form.querySelector('[name="lotNumber"]');
          const value = lotNumberInput.value;
          self.requestProducts(
              1,
              value,
              $productsContainer,
              $loader,
              textProductNotFound,
              url
          );
      }

      $form.addEventListener("submit", function(e) {
        e.preventDefault();
        submitForm();
      }, false);

      submitButton.addEventListener("click", function() {
        submitForm();
      }, false);
  }

  requestProducts(
      page,
      value,
      $productsContainer,
      $loader,
      textProductNotFound,
      url
  ) {
      $productsContainer.innerHTML = '';

      fetch(url + page, {
          method: "GET",
      })
          .then((response) => response.text())
          .then((data) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, "text/html");

              const container = doc.querySelector(".collection-certificate");
              const totalPage = parseInt(
                  container.getAttribute("data-total-page"),
                  10
              );
              const currentPage = parseInt(
                  container.getAttribute("data-current-page"),
                  10
              );
              const nextPage =
                  currentPage < totalPage ? currentPage + 1 : false;

              const product = Array.from(
                  doc.querySelectorAll(".certificate-page-product")
              ).find((el) => el.getAttribute("data-lot-id") === value);

              $productsContainer.innerHTML = '';

              if (product) {
                $productsContainer.appendChild(product);
              }

              if (nextPage) {
                  this.requestProducts(
                      nextPage,
                      value,
                      $productsContainer,
                      $loader,
                      textProductNotFound,
                      url
                  );
              } else {
                  if (!product) {
                      $productsContainer.insertAdjacentHTML(
                          "beforeend",
                          `<div class="certificate-page-errors">${textProductNotFound}</div>`
                      );
                  }
                  $loader.style.display = "none";
              }
          })
          .catch((error) => {
            console.error("Error:", error);
            $loader.style.display = "none";
            $productsContainer.insertAdjacentHTML(
                "beforeend",
                '<div class="certificate-page-errors">Something went wrong. Try again.</div>'
            );
          });
  }
}

new CertificatePage(".certificate-page-heading");
